<app-page-shell-v3>

  @if (subscriptionMessage(); as message) {
    <div role="status" class="fixed right-4 top-20 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-cp-line-strong bg-cp-surface p-4 shadow-cp">
      <div class="flex items-start gap-3">
        <ng-icon name="phosphorWarningCircle" size="18" class="mt-0.5 shrink-0 text-cp-muted" aria-hidden="true" />
        <p class="flex-1 text-[14px] text-cp-ink">{{ message }}</p>
        <button type="button" (click)="dismissToast()" aria-label="Dismiss" class="grid h-7 w-7 shrink-0 place-items-center rounded-full text-cp-subtle hover:bg-cp-fill hover:text-cp-ink">
          <ng-icon name="phosphorX" size="14" aria-hidden="true" />
        </button>
      </div>
    </div>
  }

  <app-hero-v3 />
  <app-process-v3 />
  <app-solutions-v3 />
  <app-pricing-v3 />
  <app-faq-v3 />
  <app-cta-v3 />
</app-page-shell-v3>
